import { cloneDeep, flatten, map } from '@dt/fe-utils/dist/lodash'
import { productSaleMobx, discountMobx } from '../../index'
import { ddayjs, toPrice, toDecimal } from '@dt/fe-utils'

// 根据口味组返回口味组pk <modifierGroupId>:<modifierId>*<modifierCnt>(;)...
function createModifierGroupsPk (modifierGroups: ICartModifierGroup[]) {
  return modifierGroups.map((modifierGroup: ICartModifierGroup) => modifierGroup.no + ':' + modifierGroup.modifiers.map(doItme => {
    return doItme.no + '*' + doItme.cnt
  }).join(',')).join(';')
}

// 根据套餐餐品组返回套餐餐品组pk
function createProductGroupsPk (productGroups?: IComboCartGroup[] | IViewComboCartGroup[]) {
  return productGroups?.map((group: IComboCartGroup | IViewComboCartGroup) => group.no + ':' + group.productGroupDetails.map(item => {
    return item.pk + '*' + item.cnt
  }).join(',')).join(';')
}

// 根据口味组返回口味组价格和显示字符串
// productModifierGroups 餐品的加料组 作为基准数据，会自动更新加料组的价格和加料名等
export function getModifierStrAndModifierPrice (modifierGroups: IDoModifierGroup[], productModifierGroups?: IModifierGroup[]) {
  const items: string[] = []
  const htmlItems: string[] = []
  // 是否刷新口味组取决于有没有productModifierGroups参数
  const isRenew = !!productModifierGroups
  // 由于会重新计算所以以克隆后的对象返回
  // TODO: 性能问题
  if (isRenew) {
    modifierGroups = cloneDeep(modifierGroups)
  }
  let disabled = false
  let modifierPrice = 0
  modifierGroups.forEach((modifierGroup: IDoModifierGroup) => {
    const productModifierGroup = isRenew && productModifierGroups ? productModifierGroups.find(group => group.no === modifierGroup.no) : null
    if (isRenew && !productModifierGroup) {
      disabled = true
    }
    modifierGroup.modifiers.forEach(item => {
      const productModifier = productModifierGroup ? productModifierGroup.modifiers.find(m => m.no === item.no) : null
      if (isRenew && !productModifier) {
        disabled = true
      }
      // 当前口味加料沽清
      if (item.cnt > 0 && productSaleMobx.localScaleNoToCntMap[`${item.no}_0`] && productSaleMobx.localScaleNoToCntMap[`${item.no}_0`]?.cnt === 0) {
        disabled = true
      }
      // 订单中会涉及到退菜故使用originalPrice更精准
      const isOrder = item.detailId
      const price = productModifier ? productModifier.price : (item.originalPrice || item.price)
      const name = (productModifier ? productModifier.name : item.name) || ''
      if (isRenew) {
        item.price = price
        item.name = name
      }
      let stardStr = `${name}${price ? `(${toPrice(price)})` : ''}${item.cnt > 1 ? `*${item.cnt}` : ''}`
      // 当前打印小票使用的是modifierStr, 不需要默认加料则显示No xxxx
      // 如果默认加料有价格则显示，没价格不显示
      // bo为cn 则默认加料不做额外处理
      // 美国和中国保持一致【0906需求】
      // if (item.isDefault && item.cnt === 0 && restaurantConfig.defaultModifierSpecial) {
      // // <del>
      //   htmlItems.push(`No ${item.name}`)
      //   stardStr = 'No ' + stardStr
      // } else if ((!isOrder || item.isDefault) && item.cnt === 0) {
      //   stardStr = ''
      // } else {
      //   if ((!isOrder || item.isDefault) && !price && restaurantConfig.defaultModifierSpecial) {
      //     stardStr = ''
      //   } else {
      //     // TODO 不再支持只退加料 if (item.refundCnt) {
      //     htmlItems.push(stardStr)
      //   }
      // }
      // if (stardStr) {
      //   items.push(stardStr)
      // }
      if ((!isOrder || item.isDefault) && item.cnt === 0) {
        stardStr = ''
      } else {
        // TODO 不再支持只退加料 if (item.refundCnt) {
        htmlItems.push(stardStr)
      }
      if (stardStr) {
        items.push(stardStr)
      }
      modifierPrice += price * item.cnt
    })
  })
  const modifierHtml = htmlItems.length ? `<span>${htmlItems.join(', ')}</span>` : ''
  return {
    modifierHtml,
    modifierStr: items.join(','),
    modifierPrice,
    modifierDisabled: disabled,
    // modifierGroups: isRenew ? modifierGroups : null
  }
}

// 图片
export const defaultConfig = {
  brandLogo: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIAAAACACAYAAADDPmHLAAAEYElEQVR4Xu2dbUtjMRCFU0Er2CpU//8vtAW1BV9Al8hWtlcle25u08nM0y/L0sxN5pwnkxevu7PtdvuR+IRVYAYAYb3/TBwAYvsPAMH9BwAAYBMYmgH2AKHtZxMY3H4AAADuAWIzwB4gtv8cA4P7DwAAwD1AaAbYA4S2n2NgcPsBAAC4B4jNAHuA2P5zDAzuPwAAAPcAoRlgDxDafo6Bwe0HAADgHiA2A+wBYvvPMTC4/wAAANwDhGaAPUBo+zkGBrcfAACAe4DYDLAHiO0/x8Dg/gMAAHAPEJoB9gCh7ecYGNz+DgB4fn5Ou90ufXz09c8ZzmazdHV1lS4vL01DZnoJeH9/T5vNxrSApcGtVqt0dnZWanay700DkGf/drs9mThTdLxYLExXAdMAPDw8pLe3tyl8ONkzzs/P083Nzcn6L3VsFoCfyv/19XW6uLgo5XTS719fX9Pj4+PBGCwvA2YBGJb/vKnKQuY/LX/yZjXvW/7dtFpeBswCMCz/8/k8LZdLy95/je3p6Sm9vLx8/d3yMmASgF7L/97xnpYBkwD0Wv73APS0DJgEoOfyv4egl2XAHAC9l//elgFzAPRe/ntbBswB4KH897QMmAPg/v7+4KjXw+XPb2fTn04Dd3d3po6y5gG4vb01f/nzm6P5NLBerw++BoAC/8MKYE0wdfpaz8d8BSgBMFbgVnFj+1FBG9seAP4qVwJtL7BqqNp+rJFj4wAAAGz917HqjFHbj53JY+PGjm/sjFbjqABUACpAZoA9gFo7jtReLZlq+7GlfGzc2PEdSd5vj2UJYAmwvQS0mgmt+vnfpabVeMxXgFZCtOoHAApK5xcq8zsBHj/5F0Tyi62WPuYqQP4JWv5lEG8QZPPz28HWXms3B8BwdtTuomvj1dnauj91fMP2AFCr4CAeAIwJ2tqQ1v3Vyk0FqFWQCjCxghML2npGtu6vVn0qQK2CEwM78XCKjwOAokRaAyqAplexda2gtfHFAVIBVIm09rUG1sZro02pdX/q+LgHOPJ7+QBQi+TEJbW1Ia37q5WbTWCtghMDO/Fwio8DgKJEWgMqgKZXsXWtoLXxxQFSAVSJtPa1BtbGa6PlFKDqVWxfa2BtfHGAVABVIq19rYHDeK33+tbWXgELfw9Qb6n2BADQ9PrWmgpQKWAhPNwx8Lhyfn86FaC14vQnKWC+AkjZ0FhWAABkyXwFAIAvP+VsAECWzFcAAPjyU84GAGTJfAUAgC8/5WwAQJbMVwAA+PJTzgYAZMl8BQCALz/lbABAlsxXAAD48lPOBgBkyXwFAIAvP+VsAECWzFcAAPjyU84GAGTJfAUAgC8/5WwAQJbMVwAA+PJTzgYAZMl8BQCALz/lbABAlsxXAAD48lPOBgBkyXwFAIAvP+VsAECWzFcAAPjyU84GAGTJfAUAgC8/5WwAQJbMVwAA+PJTzgYAZMl8BQCALz/lbABAlsxXAAD48lPOBgBkyXwFAIAvP+Vs/gCFP8su5/7PkgAAAABJRU5ErkJggg==',
  defaultCover: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAWgAAAFoBAMAAACIy3zmAAAAFVBMVEX09PTg4ODv7+/r6+vn5+fj4+Px8fE9WSFUAAABVElEQVR42uzYu04CQRSA4ROQ7Q8s1FDYY4I9xBeQ6AOs7/8SEi7GxHE7zUz4vmK3/TOZyVwCAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADuT+b3z/n3vo7KFaJzWXt1KTr7qFsxOvdRtUL0rvqhLkTHY2bds7oU3R3zNWpWio5NzqNmxehZ5ZO6GD3NZdSsGD3JjJoVo0N0iBY9QrTo/3TM9W1DWTYTfchtnE2zbyb66XYKneWimeiPXNzqV81EP1xvKZPMfTPRXebiMtA5NBMdm8y39eQ5cx7tRE/zattQdGzybB4tRXeHPOmHpqKj22W+DNFW9KVRdMnfRp+0GV33Y80v0auo3o/ofojqfUU3sgZFjxEteoRo0SNEix4hWvQI0aJHiG42GgAAAAAAAAAAAAAAAAAAAAAAAAAAAAA+24NDAgAAAABB/197wggAAAAA3AJGmCOvIIvURgAAAABJRU5ErkJggg==',
  defaultCoverDark: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAPAAAADwBAMAAADMe/ShAAAAIVBMVEUfIShSUlI0NTlNTU4tLjNISEkkJixCQkUnKS8+P0E6Oz6R/RzyAAABG0lEQVR42u3WsUoDQRSF4cuiayzPbmLQKhZivSBoabCyE0ur9Q3UJ9jGXt9YwyQo3rXMIZD/K4YpFv4dBmYmAAAAAAAAAAAAAAAAAAAAAGyH9GtYUft0GwY5LM3Gyo6wziKzhPUSiSF8P7pkQzjepbzLjnDd6SESQziWmkbiCB+NbLIlXGkWiSM8UZs+NITL8AdhwoR3N9xp+Dk0nOFXLcqk0twaPt/cgIdqrOFnNZs/OLGGj9evjQPpwxquOzVlwW1vDcdSehwmF9I0vOFKawtzOO5K9yrc4fpT3057ezjqS+mtD3+4dPY5vNKGRQ7PwyKHb8Ihh6+HsJDSfBRhwoQJEyb8L8KECQMAAAAAAAAAAAAAAAAAAABIvgD1jycwbk3qAwAAAABJRU5ErkJggg=='
}

// 根据餐品id 规格id和口味组返回餐品pk <productId>_<scaleId>_<modifierGroupsPk> , products?: ISingleCartItem[] | undefined
export function createFkey ({
  productNo,
  scaleNo,
  modifierGroups = [],
  addUserId = '',
  isTogo = 0,
  startTime = '',
  isSeat = '-1',
  isOrderSwapBuy = false,
  productGroups = [],
  openPriceX = -1,
  remark = '',
  price = 0
}: {
  productNo: string;
  scaleNo: string | null;
  modifierGroups: ICartModifierGroup[];
  addUserId: string;
  isTogo: 0 | 1;
  startTime?: string;
  isSeat: string;
  isOrderSwapBuy?: boolean;
  productGroups?: IComboCartGroup[] | IViewComboCartGroup[];
  openPriceX?: number;
  remark?: string;
  price?: number;
}) {
  // TODO 套餐的pk
  // let productPks = ''
  // if (products && products.length) {
  //   const ppks = sortBy(products, 'fkey').map(product => createFkey(product.productNo, product.scaleNo, product.modifierGroups))
  //   productPks = `_[${ppks.join(';')}]`
  // }
  return `${productNo}_${scaleNo}_${createModifierGroupsPk(modifierGroups || [])}_${isTogo}_${addUserId}_${startTime ? ddayjs(startTime).valueOf() : ''}_${isSeat}_${isOrderSwapBuy ? 1 : 0}_${createProductGroupsPk(productGroups || [])}_${openPriceX}_${remark}_${price}`
}

export function convertDoModifierGroupsToModifierGroups (modifierGroups: IDoModifierGroup[]) {
  return modifierGroups.map((modifierGroup) => {
    // 处理默认加料 cnt为0  isDefault 为 1
    return {
      no: modifierGroup.no,
      modifiers: modifierGroup.modifiers.filter(doModifier => doModifier.cnt || doModifier.isDefault).map(doModifier => ({
        no: doModifier.no,
        cnt: doModifier.cnt
      }))
    }
  }).filter(modifierGroup => modifierGroup.modifiers.length)
}

// 将餐品的口味变成操作的口味modifierGroups, 同时也支持加入选择的条件
export function convertModifierGroupsToDoModifierGroups (productNo: string, modifierGroups?: IModifierGroup[], cartModifierGroups?: ICartModifierGroup[]) {
  if (!modifierGroups) {
    return []
  }
  let cartModifierMap: any = {}
  if (cartModifierGroups) {
    cartModifierGroups.forEach(cartModifierGroup => {
      cartModifierGroup.modifiers.forEach(cartModifier => {
        cartModifierMap[cartModifierGroup.no + '.' + cartModifier.no] = cartModifier.cnt
      })
    })
  }
  const doModifierGroups = cloneDeep(modifierGroups) as IDoModifierGroup[]
  doModifierGroups.forEach((modifierGroup) => {
    // 处理默认选中逻辑
    let modifierGroupC = 0
    let modifierItemC = 0
    let modeFlag: 'single' | 'multiSingle' | 'multi' = modifierGroup.selectMax === 1 ? 'single' : 'multiSingle'
    modifierGroup.modifiers = modifierGroup.modifiers.map((item: IModifier) => {
      const newItem: IDoModifierGroupItem = { ...item, cnt: 0 }
      const modifySaleOut = productSaleMobx.localScaleNoToCntMap[`${item.no}_0`]
      // 口味项如果有default则置入默认cnt
      if (cartModifierMap[modifierGroup.no + '.' + item.no] !== undefined) {
        newItem.cnt = cartModifierMap[modifierGroup.no + '.' + item.no]
        modifierGroupC += newItem.cnt
        if (newItem.cnt) {
          modifierItemC++
        }
      } else if (newItem.isDefault && (!modifySaleOut || modifySaleOut?.cnt > 0)) {
        newItem.cnt = 1
        modifierGroupC++
        modifierItemC++
      }
      // if (newItem.maxCnt > 1 && (modeFlag === 'multiSingle' || modifierGroup.maxCnt === -1)) {
      if (newItem.maxCnt > 1) {
        modeFlag = 'multi'
      }
      const _key = `${productNo}_${modifierGroup?.no}_${item?.no}`
      if (discountMobx.itemDiscountMap?.[_key]) {
        newItem.discountPrice = discountMobx.itemDiscountMap?.[_key]?.off || 0
        newItem.actualPrice = toDecimal((item.price || 0) - (newItem.discountPrice || 0)) as number
      } else {
        newItem.discountPrice = 0
        newItem.actualPrice = item.price
      }
      return newItem
    })
    modifierGroup.cnt = modifierGroupC
    modifierGroup.itemCnt = modifierItemC
    modifierGroup.mode = modeFlag
    if (modifierGroup.itemCnt >= modifierGroup.selectMin && modifierGroup.itemCnt <= modifierGroup.selectMax && (modifierGroup.maxCnt === -1 || modifierGroup.cnt <= modifierGroup.maxCnt)) {
      modifierGroup.isReady = true
    }
  })
  return doModifierGroups
}

/**
 * 获取订单类型显示
 */
export const getOrderType = ({ type, data, thirdDeliveryWay }: { type?: string; data?: any; thirdDeliveryWay?: any }) => {
  const { sourceType, channel } = data
  switch (channel) {
    case 'pos':
      return type ? 'POS' : i18n.t('order.posChannel')
    case 'mobile':
      return type ? 'mobile' : i18n.t('order.mobileChannel')
    case 'kiosk':
      return 'Kiosk'
    case 'selfDelivery':
      return type ? 'selfDeliveryChannel' : i18n.t('order.selfDeliveryChannel')
    // case 'selfDelivery':
    case 'douyin':
    case 'meituan':
    case 'eleme':
    case 'buyTogether':
      return type ? channel : i18n.t('order.' + channel)
    case 'callPos':
      return type ? 'POS' : i18n.t('order.posChannel')
    case '3rdDelivery':
      return type ? sourceType : thirdDeliveryWay?.[sourceType + ''] ? thirdDeliveryWay?.[sourceType + ''].name : sourceType + ''
    case 'deliverect':
      return type ? channel : thirdDeliveryWay?.[sourceType + ''] ? thirdDeliveryWay?.[sourceType + ''].name : sourceType + ''
    case 'groupMeal':
      return type ? channel : i18n.t('order.groupMeal')
    default:
      return 'other'
  }
}

/** 检查是否在时间内 */
export const checkInTime = (startTime: string, endTime: string, timeZone: any) => {
  if (startTime && endTime) {
    const now = Date.now()
    const inTime = ddayjs(startTime, timeZone).valueOf() <= now && now < ddayjs(endTime, timeZone).valueOf()
    return inTime ? 1 : 0
  }
  return 0
}

// 处理校验供应链物料库存数据
const mergeByNo = (items: any) => {
  const result = items.reduce((obj: any, item: any) => {
    const id = `${item.productNo}${item.scaleNo}`
    if (obj[id]) {
      obj[id].cnt += item.cnt
    } else {
      obj[id] = { ...item }
    }
    return obj
  }, {})
  return Object.values(result)
}
export const dealCheckMaterialData = (saveData: any) => {
  const productList: any = []
  const modiferList: any = []
  const detailList = [
    ...saveData?.ordersDetails,
    ...(flatten(map(saveData?.ordersDetails, 'huangou').filter(i => !!i)) || []),
    ...(flatten(map(saveData?.ordersDetails, 'zengsong').filter(i => !!i)) || []),
  ]
  detailList?.forEach((item: any) => {
    if (item.type === 'product') { // 餐品
      productList.push({
        productNo: item.productNo,
        scaleNo: item.productScaleNo,
        cnt: item.cnt,
        productType: 'product'
      })
      item.productModifierGroup.forEach((mg: any) => {
        const _list = map(mg.productModifier, m => ({
          productNo: m.productModifierNo,
          scaleNo: mg.productModifierGroupNo,
          cnt: m.cnt * item.cnt,
          productType: 'modifier'
        }))
        modiferList.push(..._list)
      })
    } else if (['FixedCombo', 'OptionalCombo'].includes(item.type)) { // 套餐
      const gProductList = flatten(map(item.productGroups, 'productGroupDetails'))
      gProductList.forEach((product: any) => {
        const cnt = product.cnt * item.cnt
        productList.push({
          productNo: product.productNo,
          scaleNo: product.productScaleNo,
          cnt: cnt,
          productType: 'product'
        })
        product.productModifierGroup.forEach((mg: any) => {
          const _list = map(mg.productModifier, m => ({
            productNo: m.productModifierNo,
            scaleNo: mg.productModifierGroupNo,
            cnt: m.cnt * cnt,
            productType: 'modifier'
          }))
          modiferList.push(..._list)
        })
      })
    }
  })
  return [
    ...mergeByNo(productList),
    ...mergeByNo(modiferList),
  ]
}
